import React from 'react';
import { X, User, Building } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ContactBookSelection } from './ContactBookTypes';
import { cn } from '@/lib/utils';

interface ContactSelectedBadgeProps {
  selection: ContactBookSelection;
  onClear: () => void;
  mode?: 'dialer' | 'email';
  className?: string;
}

export const ContactSelectedBadge = ({
  selection,
  onClear,
  mode = 'dialer',
  className
}: ContactSelectedBadgeProps) => {
  const { contact, selectedPhone, selectedEmail } = selection;
  const displayValue = mode === 'dialer' ? selectedPhone : selectedEmail;

  return (
    <div className={cn(
      "flex h-10 w-full items-center justify-between bg-background border border-input rounded-md px-3",
      "transition-all duration-200 ease-in-out",
      className
    )}>
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <User className="h-4 w-4 flex-shrink-0 text-foreground" />
        <span className="text-sm font-medium truncate text-foreground">
          {contact.full_name}
        </span>
        
        {contact.lead_name && (
          <>
            <span className="text-muted-foreground">•</span>
            <span className="text-xs truncate text-muted-foreground">
              {contact.lead_name}
            </span>
          </>
        )}
      </div>

      <Button
        variant="ghost"
        size="sm"
        onClick={(e) => {
          console.log('❌ X button clicked on contact badge');
          e.preventDefault();
          e.stopPropagation();
          console.log('🎯 Calling onClear function');
          onClear();
          console.log('✅ onClear function called');
        }}
        className="h-6 w-6 p-0 hover:bg-destructive/10 hover:text-destructive flex-shrink-0 ml-2 cursor-pointer"
        aria-label="Clear selected contact"
      >
        <X className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
};